export default "/images/vendor/flag-icon-css/flags/1x1/cm.svg?0dcbc4f1fe098b1b8725ef1a2b98dae4";